import { AboutUs } from "../../entities/AboutUs/ui/AboutUs";
import Doctors from "../../entities/Doctors/ui/Doctors";
import { InfoCard } from "../../entities/InfoCards/ui/InfoCard";
import Services from "../../entities/Services/ui/Services";
import Steps from "../../entities/Steps/ui/Steps";
import Footer from "../../widgets/Footer/ui/FooterContact/Footer";
import FooterInfo from "../../widgets/Footer/ui/FooterInfo/FooterInfo";

import { HeaderMain } from "../../widgets/Header/ui/HeaderMain/HeaderMain";
import styles from './MainPage.module.scss'

export const MainPage = () => {

    return(
        <main className={styles.main}>
        <div>
          <HeaderMain/>
          <InfoCard/>
          <AboutUs/>
          <Steps/>
          <Doctors/>        
          <Services/>
        
          <Footer/> 
          <FooterInfo/>     
        </div>
        </main>
    )
}